import { render, staticRenderFns } from "./PromotionList.vue?vue&type=template&id=c5929454&scoped=true"
import script from "./PromotionList.vue?vue&type=script&lang=js"
export * from "./PromotionList.vue?vue&type=script&lang=js"
import style0 from "./PromotionList.vue?vue&type=style&index=0&id=c5929454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5929454",
  null
  
)

export default component.exports